// Shared vocabulary for the consolidated Performance surface (#5971).
// The platform scope switch (All / Google / Meta) drives every tab; the money
// and Results layers build on these common types.

export type Platform = 'google' | 'meta';

// The master scope switch value. 'all' shows both platforms side by side —
// never merged into a single false-equivalence figure (see results.ts).
export type PlatformScope = 'all' | 'google' | 'meta';

export const PLATFORMS: readonly Platform[] = ['google', 'meta'] as const;

/** The platforms a given scope covers. */
export function platformsInScope(scope: PlatformScope): Platform[] {
  return scope === 'all' ? [...PLATFORMS] : [scope];
}
